// Hinweis-Fenster eines Standorts (Inhalt aus src/data/hinweis_*.json, gepflegt über /admin).
// Erscheint nur im Zeitraum data-von/data-bis und nur einmal pro Besucher,
// bis sich der Inhalt ändert.

const DISMISSED_KEY = 'opening-notice-dismissed';

// "2026-10-01" als lokaler Tagesbeginn, bei endOfDay als Beginn des Folgetags.
// Wird auch von der CMS-Vorschau (src/admin/preview.ts) genutzt.
export function parseDay(value: string | undefined, endOfDay: boolean): number | null {
    if (!value) return null;
    const day = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (day) return new Date(+day[1], +day[2] - 1, +day[3] + (endOfDay ? 1 : 0)).getTime();
    const time = Date.parse(value);
    return Number.isNaN(time) ? null : time;
}

function isInPeriod(dialog: HTMLElement): boolean {
    const now = Date.now();
    const from = parseDay(dialog.dataset.von, false);
    const until = parseDay(dialog.dataset.bis, true);
    return (from === null || now >= from) && (until === null || now < until);
}

// Kurzer Fingerabdruck des Inhalts, damit ein geänderter Hinweis wieder erscheint.
function contentHash(text: string): string {
    let hash = 5381;
    for (let i = 0; i < text.length; i++) hash = (hash * 33) ^ text.charCodeAt(i);
    return (hash >>> 0).toString(36);
}

function readDismissed(): string | null {
    try { return localStorage.getItem(DISMISSED_KEY); } catch { return null; }
}

function saveDismissed(hash: string): void {
    try { localStorage.setItem(DISMISSED_KEY, hash); } catch { /* z. B. privater Modus */ }
}

export function initOpeningNotice(): void {
    const dialog = document.querySelector<HTMLDialogElement>('#opening-notice');
    if (!dialog || !isInPeriod(dialog)) return;

    // Use the same hours as the existing panel so future edits stay in sync.
    const hours = dialog.querySelector('.opening-notice-hours');
    const source = document.querySelector('#opening-hours-panel');
    if (hours && source) {
        hours.replaceChildren(...Array.from(source.querySelectorAll('ul'), list => list.cloneNode(true)));
    }

    const hash = contentHash((dialog.textContent || '').replace(/\s+/g, ' ').trim());
    if (readDismissed() === hash) return;

    dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('opening-notice-visible');
        saveDismissed(hash);
    });
    dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.showModal();
    document.documentElement.classList.add('opening-notice-visible');
}
